<ng-container *transloco="let gt; read: 'general'">
  <!-- DXP agreement -->
  @if ((isUkShfyInstance$ | async) || (isUkDfpInstance$ | async)) {
    <div data-test-id="agreement-preview-is-dxp" class="is-dxp">
      <div
        data-test-id="agreement-preview-dxp-dialog-content"
        mat-dialog-content
        cdkScrollable
        #scrollable
        class="px-0 px-sm-4"
      >
        <div
          data-test-id="agreement-preview-dxp-html"
          [innerHtml]="sanitizedAgreementHtml$ | async"
        ></div>
      </div>
      <div data-test-id="agreement-preview-dxp-actions" mat-dialog-actions class="flex-row-reverse">
        <button
          data-test-id="agreement-preview-dxp-close-btn"
          class="btn btn-primary"
          cdkFocusInitial
          mat-dialog-close
        >
          {{ gt('closeButton') }}
        </button>
      </div>
    </div>
  }
  <!-- [end] DXP agreement -->

  @if (!(isUkShfyInstance$ | async) && !(isUkDfpInstance$ | async)) {
    <div
      data-test-id="agreement-preview-agreement-wrapper"
      mat-dialog-content
      cdkScrollable
      #scrollable
      class="px-0 px-sm-4"
    >
      <div
        data-test-id="agreement-preview-html"
        [innerHtml]="sanitizedAgreementHtml$ | async"
      ></div>
    </div>
  }
  @if (!(isUkShfyInstance$ | async) && !(isUkDfpInstance$ | async)) {
    <div data-test-id="agreement-preview-actions" mat-dialog-actions class="flex-row-reverse">
      <button
        data-test-id="agreement-preview-close-btn"
        class="btn btn-primary"
        cdkFocusInitial
        mat-dialog-close
      >
        {{ gt('closeButton') }}
      </button>
    </div>
  }
</ng-container>
